/* Built In Imports */
import { useContext, useEffect } from 'react';

/* External Imports */
/* Internal Imports */
/* Components */
import ProjectSamskritiUI from '@components/UI/ProjectSamskriti';
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import Navbar from '@landing_pages/project-samskriti/Navbar';
import WrapLayout from '@Layout/WrapLayout';
import { AuthContext } from '@store/auth-context';

/* Services */
import {
    getLocale
} from '@components/Utility/Shared/SharedService';
import {
    fetchFooterData, fetchHeaderMenuData, fetchHeaderTopMenuData
} from 'services/commonService';
import { fetchDetails, getLandingPaths } from 'services/othersService';

/* Styles */

/**
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} pageData - Events Landing Page Data
 */
const ProjectSamskritiProgram = ({
  region,
  language,
  pageData,
  headerMenuData,
}) => {
  const authContext = useContext(AuthContext);

  useEffect(() => {
    authContext.RegionAndLang(region, language);
  }, [authContext, region, language]);
  return (
    <WrapLayout>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData.availableLocales}
      >
        {' '}
      </HeadComponent>
      {headerMenuData?.allIsoMainMenus?.length ? (
        <Navbar
          headerData={headerMenuData.allIsoMainMenus}
          region={region}
          lang={language}
        />
      ) : null}
      <ProjectSamskritiUI
        region={region}
        lang={language}
        pageBody={pageData.body}
      />
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  const projectSamskritiProgramPaths = config.USE_LOCAL_URL
    ? [
        `/in/en/project-samskriti/guru-paduka-stotram`,
        `/in/en/project-samskriti/shiva-shiva-vachana`,
        `/in/en/project-samskriti/nirvana-shatakam`,
        `/in/en/project-samskriti/bharatanatyam`,
        `/in/en/project-samskriti/niraive-shakti`,
        `/in/en/project-samskriti/nirvana-shatakam`,
        `/in/en/project-samskriti/kalaripayattu`,
      ]
    : await getLandingPaths('L1', '/project-samskriti/');
  return {
    paths: projectSamskritiProgramPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { region, language, program },
  req,
}) => {
  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale(region, language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale(region, language),
    'samskriti'
  );
  const footerData = await fetchFooterData(
    getLocale(region, language),
    'isofooter'
  );
  const pageData = await fetchDetails(
    region,
    language,
    `project-samskriti/${program}`,
    { preview, data: previewData }
  );

  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: region,
      language: language,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      isPreview: preview ? true : false,
      page: 'Samskriti'
    }
  };
};

export default ProjectSamskritiProgram;
